export default "__VITE_ASSET__b09fc3db__"